const markers = [25, 50, 75];

export function ProgressMarkers() {
  return (
    <>
      {markers.map((pct) => (
        <div
          key={pct}
          className="absolute top-0 bottom-0 flex flex-col items-center pointer-events-none"
          style={{ left: `${pct}%` }}
        >
          <div className="w-px h-full bg-track-marking" />
          <span className="absolute top-1 -translate-x-1/2 text-[9px] font-bold tracking-wider text-text-muted/60 tabular-nums">
            {pct}
          </span>
        </div>
      ))}
      {/* Start marker */}
      <div className="absolute top-0 bottom-0 left-0 w-px bg-text-muted/15 pointer-events-none" />
    </>
  );
}
